export const ARTICLE_CONTACTS = 'main.contact'
export const ARTICLE_ABOUT_US = 'main.about-us'
export const ARTICLE_SHIPPING = 'main.shipping'
export const ARTICLE_HOME = 'main.home-page'
export const ARTICLE_TERMS = 'main.terms'
export const ARTICLE_CAREER = 'main.career'
export const ARTICLE_COMPLAINT = 'main.complaint'
export const ARTICLE_EU = 'bf.transformation'

// Profile
export const PROFILE_EDIT = 'main.user.profile'
export const PROFILE_ORDERS = 'main.user.orders'
export const PROFILE_ADDRESSES = 'main.user.addresses'
export const PROFILE_LOYALTY = 'bf.loyalty'
export const PROFILE_REMINDERS = 'bf.reminders'
export const PROFILE_REGISTER = 'main.user.registration'

export const ARTICLE_NOT_FOUND = 'main.not-found'
export const ARTICLE_ERROR = 'main.error'

//TOOD: PERMANENT ROUTE?..
export const ARTICLE_PRIVACY = 'main.privacy'
export const ARTICLE_ADDRESS = 'main.address'
export const ARTICLE_DENIED = 'main.denied'
export const ARTICLE_PARTNERS = 'main.partners'
export const ARTICLE_RATING = 'bf.rating'
export const ARTICLE_RATING_BAD = 'bf.rating.negative'
